// extracted by mini-css-extract-plugin
export var box = "_4s-0";
export var check = "_4s-1";
export var checkboxButton = "_4s-6";
export var checkboxGroup = "_4s-5";
export var disabled = "_4s-7";
export var ghost = "_4s-9";
export var input = "_4s-2";
export var label = "_4s-4";
export var normal = "_4s-8";
export var uncheck = "_4s-3";